import React from 'react';
import styled from 'styled-components';
import { FilterLabel } from '@lt/components';
import { StyledFilterGroupLabel } from '@lt/components/components/FilterGroup/FilterGroup';
import { useTranslation, i18n } from '@lt/localization';
import { FilterPropTypes, FilterDefaultProps } from './proptypes';
import MultichoiceFilterGroup from './components/MultichoiceFilterGroup';

const LABEL_TEXT = i18n.t('filters.benefit.hotelTitle');

const getFilterLabel = () => <Label>{LABEL_TEXT}</Label>;

const FilterHotelBenefits = (props) => {
  const { t } = useTranslation();
  return (
    <StyledMultichoiceFilterGroup
      {...props}
      Filter={{
        filterLabel: getFilterLabel(),
        ...FilterHotelBenefits,
      }}
      expandLabel={t('filters.show_offers')}
      visibleItems={5}
      LabelComponent={FilterLabel}
    />
  );
};

const StyledMultichoiceFilterGroup = styled(MultichoiceFilterGroup)`
  ${StyledFilterGroupLabel} {
    svg {
      margin-left: 5px !important;
    }
  }
`;

const Label = styled.span`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;

FilterHotelBenefits.filterName = 'hotel_benefits';

FilterHotelBenefits.propTypes = FilterPropTypes;
FilterHotelBenefits.defaultProps = FilterDefaultProps;

export default FilterHotelBenefits;
